/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * User type group
 * @export
 */
export const ControlType3 = {
    Vip: 'VIP',
    Admin: 'ADMIN',
    External: 'EXTERNAL',
    Technical: 'TECHNICAL',
    Financial: 'FINANCIAL',
    Nhi: 'NHI',
    Other: 'Other'
} as const;
export type ControlType3 = typeof ControlType3[keyof typeof ControlType3];


export function ControlType3FromJSON(json: any): ControlType3 {
    return ControlType3FromJSONTyped(json, false);
}

export function ControlType3FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlType3 {
    return json as ControlType3;
}

export function ControlType3ToJSON(value?: ControlType3 | null): any {
    return value as any;
}

